<template>
  <span>
    <login-cool v-if="this.$route.params.uname"></login-cool>
    <template v-else>
    <header-cool></header-cool>
     
    <body-cool></body-cool>
    <footer-cool></footer-cool>
    </template>
  </span>
</template>
<script>
//import 'bootstrap-css-only/css/bootstrap.min.css'; 
//import 'mdbvue/build/css/mdb.css';
//import MainMenu from '@/components/ThemeMDB/menu/MainMenu';
import HeaderCool from '@/components/ThemeMDB/home/Header';
import BodyCool from '@/components/ThemeMDB/home/Body';
import FooterCool from '@/components/ThemeMDB/home/Footer';
import LoginCool from '@/components/ThemeMDB/home/partials/Login';

export default {
    name: 'ThemeMDB',
    components:{
       // MainMenu,
        HeaderCool,
        BodyCool,
        FooterCool,
        LoginCool     
    },
    created:function(){
      //this.showContent(this.$route.params.lname)
      console.log(this.$route.params.uname)
    }
};
</script>
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

